import {Injectable} from '@angular/core';
import {DemographicGovtQuestions} from '../schema/loan-appication/demographic-govt-questions';
import {Declaration} from '../schema/loan-appication/declaration';

@Injectable({
    providedIn: "root"
})
export class LoanApplicationConstant{
    declarationMap = new Map();
    demographicMap = new Map();
    validationMessage = new Map<number,string>();

    init() {
        this.declarationMap.set(1,'A. Will you occupy the property as your primary residence?');
        this.declarationMap.set(2,'If YES, have you had an ownership interest in another property in the last three years?');
        this.declarationMap.set(3,'B. If this is a Purchase Transaction: Do you have a family relationship or business affiliation with the seller of the property?');
        this.declarationMap.set(4,'C. Are you borrowing any money for this real estate transaction?');
        this.declarationMap.set(5,'D. 1. Have you or will you be applying for a mortgage loan on another property (not the property securing this loan) on or before closing this transaction that is not disclosed on this loan application?');
        this.declarationMap.set(6,'2. Have you or will you be applying for any new credit (e.g., installment loan, credit card, etc.) on or before closing this loan that is not disclosed on this application?  ');
        this.declarationMap.set(7,'E. Will this property be subject to a lien that could take priority over the first mortgage lien, such as a clean energy lien paid through your property taxes (e.g., the Property Assessed Clean Energy Program)?');
        this.declarationMap.set(8,'F. Are you a co-signer or guarantor on any debt or loan that is not disclosed on this application?');
        this.declarationMap.set(9,'G. Are there any outstanding judgments against you?');
        this.declarationMap.set(10,'H. Are you currently delinquent or in default on a Federal debt?');
        this.declarationMap.set(11,'I. Are you a party to a lawsuit in which you potentially have any personal financial liability?');
        this.declarationMap.set(12,'J. Have you conveyed title to any property in lieu of foreclosure in the past 7 years?');
        this.declarationMap.set(13,'K. Within the past 7 years, have you completed a pre-foreclosure sale or short sale, whereby the property was sold to a third party and the Lender agreed to accept less than the outstanding mortgage balance due?');
        this.declarationMap.set(14,'L. Have you had property foreclosed upon in the last 7 years?  ');
        this.declarationMap.set(15,'M. Have you declared bankruptcy within the past 7 years? ');

        this.demographicMap.set(1,'Ethnicity');
        this.demographicMap.set(2,'Gender');
        this.demographicMap.set(3,'Race');
        this.demographicMap.set(4,'Was the ethnicity of the Borrower collected on the basis visual observation or surname?');
        this.demographicMap.set(5,'Was the sex of the Borrower collected on the basis visual observation or surname?');
        this.demographicMap.set(6,'Was the race of the Borrower collected on the basis visual observation or surname?');
        this.demographicMap.set(7,'Demographic Information Provided Type');
        this.demographicMap.set(8,'Application Signed Date');

        //validation messages
        this.validationMessage.set(1,'First Name is required');
        this.validationMessage.set(2,'Last Name is required');
        this.validationMessage.set(3,'SSN is required');
        this.validationMessage.set(4,'Date of Birth is required');
        this.validationMessage.set(5,'Contact Email is required');
        this.validationMessage.set(6,'Phone is required');
     }
    getDeclarationQuestionById(questionId: number){
        if(this.declarationMap.size === 0) {
            this.init();
        }
        return  this.declarationMap.get(questionId);
    }
    getDemographicById(questionId: number){
        if(this.demographicMap.size === 0) {
            this.init();
        }
        return  this.demographicMap.get(questionId);
    }
    getDemographics(): DemographicGovtQuestions[]{
        const demographic = [];
        demographic.push(new DemographicGovtQuestions(1, false));
        demographic.push(new DemographicGovtQuestions(2, false));
        demographic.push(new DemographicGovtQuestions(3, false));
        demographic.push(new DemographicGovtQuestions(4, false));
        demographic.push(new DemographicGovtQuestions(5, false));
        demographic.push(new DemographicGovtQuestions(6, false));
        demographic.push(new DemographicGovtQuestions(7, false));
        demographic.push(new DemographicGovtQuestions(8, false));
        return demographic;


    }
    getDeclarations(): Declaration[]{
        const declarations = [];
        declarations.push(new Declaration(1, false));
        declarations.push(new Declaration(2, false));
        declarations.push(new Declaration(3, false));
        declarations.push(new Declaration(4, false));
        declarations.push(new Declaration(5, false));
        declarations.push(new Declaration(6, false));
        declarations.push(new Declaration(7, false));
        declarations.push(new Declaration(8, false));
        declarations.push(new Declaration(9, false));
        declarations.push(new Declaration(10, false));
        declarations.push(new Declaration(11, false));
        declarations.push(new Declaration(12, false));
        declarations.push(new Declaration(13, false));
        declarations.push(new Declaration(14, false));
        declarations.push(new Declaration(15, false));
        return declarations;
    }
    getValidationMessage(messageId : number):string{
     if(this.validationMessage.size === 0) {
        this.init();
      }
      return this.validationMessage.get(messageId);
    }

   UserRoles = {
    Borrower: "BORROWER",
    Loan_Officer: "LOAN_OFFICER",
    Broker: "BROKER",
    Enterprise_Admin: "ENTERPRISE_ADMIN",
    Client_Admin: "CLIENT_ADMIN",
    Account_Admin: "ACCOUNT_ADMIN",
  }
  SessionStorageKey ={
    LENDINGMAN_ID_TOKEN :'LENDINGMAN-ID-TOKEN',
    APP_USER :'APP-USER',
    TAXONOMIES : 'taxonomies',

  }
  TaxonomyGroup ={
      LOAN_APPLICATION_TAXONOMY_GROUP : 101,
  }
  ExternalServiceType ={
    LOS : 101,
  }
  ServiceOperationType ={
    CREATE_LOAN : 101,
    SAVE_LOAN : 102,
  }






}
